import { HttpClient } from '@angular/common/http';
import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { lastValueFrom } from 'rxjs';
import { SharedModule } from 'src/app/layouts/full/shared/shared.module';
import { UserService } from 'src/app/services/user.service';
import { VolumentalService } from 'src/app/services/volumental.service';
import { environment } from 'src/environments/environment';
import { toLeopoloyDesignEngine } from '../insoles-prescription/insolesPrescriptionMaper';
import { InsolesPrescriptionResponse } from 'src/app/models/formResponse.model';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { PrescriptionTemplate, PrescriptionTemplatesService } from 'src/app/services/prescription-templates.service';
import { ScanService } from 'src/app/services/scan.service';
import JSZip from 'jszip';

declare global {
  interface Window {
    Volumental: any;
  }
}

interface ScanDetails {
  id: string,
  created_at: Date,
  scans: {
    left_length: number,
    left_width: number,
    left_instep_height: number,
    right_length: number,
    right_width: number,
    right_instep_height: number
  },
  meshes: {
    left_foot: string,
    right_foot: string
  }
}

@Component({
  selector: 'app-volumental',
  standalone: true,
  imports: [SharedModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './volumental.component.html',
  styleUrl: './volumental.component.scss'
})
export class VolumentalComponent {
  userId = 'user-123'; // idealmente el ID real del usuario logueado
  response = null;
  private widgetId = 'volumental-widget';
  scanDetails: ScanDetails | null = null
  isLoading: boolean = true
  prescriptionTemplate: PrescriptionTemplate
  prescriptionTemplateId: string
  orderId: string | null = null
  name: string | null = null
  surname: string | null = null
  gender: string | null = null
  clientId: string | null = null
  scanCreated: boolean = false
  formResponseId: string | null = null
  signedZipUrl: string = ''

  // Para el 3D Previewer
  show3DPreviewer = false
  token: string;
  iframeUrl: SafeResourceUrl;
  respuesta: any
  isIframeReady: boolean = false
  insolePrescription: FormGroup | null = null

  constructor(
    private http: HttpClient,
    private volumentalService: VolumentalService,
    private userService: UserService,
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private prescriptionTemplatesService: PrescriptionTemplatesService,
    private scanService: ScanService
  ) { }

  ngOnInit(): void {
    this.prescriptionTemplateId = this.route.snapshot.paramMap.get('prescriptionTemplateId')
    this.route.queryParams.subscribe(params => {
      this.orderId = decodeURIComponent(params['orderId']);
      this.name = decodeURIComponent(params['name']);
      this.surname = decodeURIComponent(params['surname']);
      this.gender = decodeURIComponent(params['gender']);
      this.clientId = decodeURIComponent(params['clientId']);
      this.formResponseId = decodeURIComponent(params['formResponseId']);
    });
    // Escuchar cuando el SDK de Volumental esté cargado
    window.addEventListener('volumental:on-loaded', () => {
      console.log('Volumental SDK loaded, window.Volumental is now available');
    });

    this.loginOfLeopoly()
    this.getPrescriptionTemplate(this.prescriptionTemplateId)
    this.createScan()
  }

  ngAfterViewInit(): void {
    // Esperar un momento para que el elemento esté completamente renderizado
    setTimeout(() => {
      this.setupEventListeners();
    }, 100);
  }

  setupEventListeners() {
    const element = document.getElementById(this.widgetId);

    if (!element) {
      console.error(`Could not find element with id ${this.widgetId}`);
      return;
    }

    // Evento cuando se abre el modal
    element.addEventListener('volumental:on-opened', () => {
      console.log('Volumental modal opened');
    });

    // Evento cuando se cierra el modal
    element.addEventListener('volumental:on-closed', () => {
      console.log('Volumental modal closed');
      // Solo mostrar el 3D previewer si hay prescriptionTemplateId
      if (this.prescriptionTemplateId) {
        console.log('Showing 3D previewer with prescription template');
        this.show3DPreviewer = true;
      } else {
        console.log('No prescription template, redirecting to home');
        this.goToHome();
      }
    });

    // Evento cuando se recibe una medición
    element.addEventListener('volumental:on-measurement', (e: any) => {
      const { id } = e.detail;

      this.response = e.detail;
      this.getScanDetails(id)
    });

    // Evento cuando ocurre un error
    element.addEventListener('volumental:on-error', (e: any) => {
      const { message } = e.detail;
      console.error('Volumental error:', message);
    });
  }

  loginOfLeopoly() {
    const payload = {
      "Username": environment.leopoly.three_d_preview_viewer.username,
      "Password": environment.leopoly.three_d_preview_viewer.password
    };

    this.userService.leopolyLogin3DPreviewer(payload).subscribe({
      next: (res: any) => {
        this.token = res.token;
        const safeUrl: any = this._generateSafeUrl(this.token);
        if (safeUrl) {
          this.iframeUrl = safeUrl;

          window.removeEventListener("message", this.receiveMessage, false);
          window.addEventListener("message", this.receiveMessage, false);

          console.log("Iframe cargando con token...");
          console.log("iframe url: ", this.iframeUrl)
        }
      },
      error: (err) => {
        console.error(err)
      }
    });
  }

  private _generateSafeUrl(token: string): SafeResourceUrl {
    // Construct the URL with the token
    let baseUrl = environment.leopoly.three_d_preview_viewer.base_url
    let url = `${baseUrl}?token=${token}`;

    // Sanitize the URL to make it safe
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  receiveMessage = (event: MessageEvent) => {
    console.log("Received message from iframe:", event.data);
    let iframe;

    iframe = document.getElementById("3D_previewer") as HTMLIFrameElement;

    if (event.data && event.data.EVENT_NAME === "loaded_IFrame") {
      console.log("Received loaded_IFrame");
      this.isLoading = false
      this.isIframeReady = true;
      if (this.respuesta) {
        // Limpiamos datos para evitar errores de clonación
        const safeData = JSON.parse(JSON.stringify(this.respuesta));
        iframe.contentWindow.postMessage(safeData, "*");
      }
    }

    if (event.data && event.data.EVENT_NAME === "closed_IFrame") {
      window.close();
    }
  };

  async getScanDetails(scanId: string) {
    this.scanDetails = await lastValueFrom(
      this.volumentalService.getScanDetails(scanId)
    );

    if (this.scanCreated) {
      await this.uploadScanZip();
    } else {
      console.warn('Scan not yet created, retrying in 5 seconds...');

      await this.delay(5000);

      if (this.scanCreated) {
        await this.uploadScanZip();
      } else {
        console.warn('Scan still not created, skipping ZIP upload');
      }
    }
  }

  private delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async getPrescriptionTemplate(prescriptionTemplateId: string) {
    if (!prescriptionTemplateId) {
      console.log('No prescriptionTemplateId provided, skipping prescription template loading');
      return;
    }

    try {
      this.prescriptionTemplate = await lastValueFrom(this.prescriptionTemplatesService.getPrescriptionTemplateByID(prescriptionTemplateId))

      // Convertir la prescription template a FormGroup
      if (this.prescriptionTemplate && this.prescriptionTemplate.prescription) {
        this.insolePrescription = this.convertPrescriptionToFormGroup(this.prescriptionTemplate.prescription)
      }
    } catch (error) {
      console.error('Error loading prescription template:', error);
    }
  }

  private convertPrescriptionToFormGroup(prescription: any): FormGroup {
    // Crear el FormGroup basado en la estructura de la prescription
    const formGroup = this.formBuilder.group({
      shellType: [prescription.shellType || null],
      lengthType: [prescription.lengthType || null],
      thinThickness: [prescription.thinThickness || null],
      components: this.formBuilder.array([])
    });

    // Si hay componentes, agregarlos al FormArray
    if (prescription.components && Array.isArray(prescription.components)) {
      const componentsArray = formGroup.get('components') as FormArray;
      prescription.components.forEach((component: any) => {
        componentsArray.push(this.formBuilder.group(component));
      });
    }

    return formGroup;
  }

  async sendDataToLeopoly() {
    let question: InsolesPrescriptionResponse = {
      title: "",
      type: "insolesPrescription",
      components: []
    }

    // Si no hay prescription template, usar valores por defecto
    if (!this.insolePrescription) {
      console.log('No prescription template available, using default values');

      const respuesta = {
        EVENT_NAME: "init_data",
        data: {
          scan_import_data: {
            right: {
              url: this.scanDetails.meshes.right_foot,
              format: "obj",
              scanMode: "non-weighted"
            },
            left: {
              url: this.scanDetails.meshes.left_foot,
              format: "obj",
              scanMode: "non-weighted"
            }
          },
          file_name_data: {
            patient_name: this.name || "Patient",
            version: 1,
            order_id: this.orderId || "123"
          },
          insole_parameters: toLeopoloyDesignEngine(
            question,
            false,
            undefined,
            null, // shellType
            null, // lengthType
            null  // thinThickness
          ),
          export_URL: "test",
          embossed_logo_svg: "<svg></svg>"
        }
      };

      this.respuesta = respuesta;
      return;
    }

    // Obtener todos los componentes del formulario que tienen footSelection válido
    const componentsArray = this.insolePrescription.get('components') as FormArray;
    const viewerData = componentsArray.controls
      .map((formGroup: FormGroup) => formGroup.getRawValue())
      .filter((component: any) => {
        const footSelection = component.footSelection;
        return footSelection !== null && footSelection !== undefined && footSelection !== '';
      });

    console.log("viewerData: ", viewerData)

    question.components = viewerData

    const respuesta = {
      EVENT_NAME: "init_data",
      data: {
        scan_import_data: {
          right: {
            url: this.scanDetails.meshes.right_foot,
            format: "obj",
            scanMode: "non-weighted"
          },
          left: {
            url: this.scanDetails.meshes.left_foot,
            format: "obj",
            scanMode: "non-weighted"
          }
        },
        file_name_data: {
          patient_name: this.name || "Patient",
          version: 1,
          order_id: this.orderId || "123"
        },
        insole_parameters: toLeopoloyDesignEngine(
          question,
          false,
          undefined,
          this.insolePrescription.get('shellType')?.value,
          this.insolePrescription.get('lengthType')?.value,
          this.insolePrescription.get('thinThickness')?.value
        ),
        export_URL: "test",
        embossed_logo_svg: "<svg></svg>"
      }
    };

    this.respuesta = respuesta
    // window.addEventListener("message", this.receiveMessage, false);
    // const iframe = document.getElementById("design_engine") as HTMLIFrameElement;

    // iframe.contentWindow.postMessage(respuesta, "*");


    // const url = this.router.serializeUrl(
    //   this.router.createUrlTree(['/design/design-engine'], { queryParams: { id: this.order.ID, data: JSON.stringify(respuesta) } })
    // );

    // window.open(url, '_blank');
  }

  async createScan() {
    const scan = {
      ID: this.orderId,
      identifier: "",
      clientId: this.clientId,
      data: {
        'Patient Data': {
          name: this.name,
          surname: this.surname,
          sex: this.gender,
        }
      },
      date: Date.now().toString(),
      paid: true,
      formResponseId: this.formResponseId
    };

    try {
      const scanResult = await lastValueFrom(this.scanService.newScan(scan))
      this.signedZipUrl = scanResult.signedZipUrl
      this.scanCreated = true;
      console.log('Scan created successfully');
    } catch (error) {
      this.scanCreated = false;
      console.error('Error creating scan:', error)
    }
  }

  async uploadScanZip() {
    try {
      const blob = await this.createZipFile();

      await lastValueFrom(this.scanService.uploadZipFile(this.signedZipUrl, blob));
      console.log('ZIP uploaded successfully');
    } catch (error) {
      console.error('Error uploading scan ZIP:', error)
    }
  }

  async createZipFile(): Promise<Blob> {
    const zip = new JSZip();
    const prefix = `${this.name}_${this.surname}`;

    // Descargar y añadir el OBJ del pie izquierdo
    if (this.scanDetails?.meshes?.left_foot) {
      const leftResponse = await fetch(this.scanDetails.meshes.left_foot);
      const leftBlob = await leftResponse.blob();
      zip.file(`${prefix}_left_foot_plantarSurface.obj`, leftBlob);
    }

    // Descargar y añadir el OBJ del pie derecho
    if (this.scanDetails?.meshes?.right_foot) {
      const rightResponse = await fetch(this.scanDetails.meshes.right_foot);
      const rightBlob = await rightResponse.blob();
      zip.file(`${prefix}_right_foot_plantarSurface.obj`, rightBlob);
    }

    return zip.generateAsync({ type: 'blob' });
  }

  goToHome() {
    this.show3DPreviewer = false
    this.router.navigate(['/home'])
  }

  on3DModalShown() {
    this.sendDataToLeopoly();
  }
}
